<template>
  <div id="part1" class="m-sm-5 m-3 px-sm-3 px-1">
    <b-form-group label="Donate as" label-class="required" class="mb-5">
      <b-form-radio-group
        :options="donorType.options"
        v-model="donorType.value"
        buttons
        button-variant="outline-primary"
        class="split-radio-btns"
      />
    </b-form-group>
    <b-form-group
      label="Donate"
      label-class="required"
      button-variant="outline-primary"
      class="golf-payment"
    >
      <div class="golf-payment__price-container">
        <div>
          <b-form-radio
            v-model="amt"
            name="amt"
            :value="6000"
            size="md"
            class="bg-white golf-payment__radio mr-3 golf-payment"
            >$6,000</b-form-radio
          >
          <p>For 1 flight</p>
        </div>

        <div>
          <b-form-radio
            v-model="amt"
            name="amt"
            :value="10000"
            size="md"
            class="bg-white golf-payment__radio mr-3 golf-payment"
            >$10,000</b-form-radio
          >
          <p>For 2 flights</p>
        </div>
      </div>

      <div class="mt-3 other-amount">
        <b-form-radio
          v-model="amt"
          name="amt"
          :value="customamt"
          button
          button-variant="outline-primary"
          size="md"
          class="bg-white mr-3 golf-payment__radio other-amount-wrap"
        >
          <div
            class="d-sm-flex align-items-baseline other-amount-inner"
            style="display: inline-flex"
          >
            <span
              class="flex-grow-1"
              style="
                margin-right: 8px;
                font-weight: normal;
                font-size: 12px;
                line-height: 20px;
                color: #545454;
                max-width: 40%;
              "
              >Custom Amount</span
            >
            <div class="d-flex align-items-baseline" style="max-width: 60%">
              <b-input
                v-model="customamt"
                type="number"
                @focus="amt = customamt"
                min="1"
                step="1"
                class="bg-hs-pastel-crimson"
                lazy-formatter
                :formatter="cleanAmt"
              />
            </div>
          </div>
        </b-form-radio>
      </div>
      <p v-if="showDonationRequiredMessage" class="donation-required-warning">
        * Please Select Donation Amount
      </p>
    </b-form-group>

    <b-form-group class="mb-5 paymentmethod">
      <legend
        id="donnation_freq_sel__BV_label_"
        tabindex="-1"
        class="bv-no-focus-ring col-form-label pt-0"
      >
        <span class="required">Payment method</span>
        <div class="question-mark">
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 10C2.2385 10 0 7.7615 0 5C0 2.2385 2.2385 0 5 0C7.7615 0 10 2.2385 10 5C10 7.7615 7.7615 10 5 10ZM4.5 6.5V7.5H5.5V6.5H4.5ZM5.5 5.6775C5.90183 5.55639 6.2468 5.29498 6.47208 4.94087C6.69735 4.58677 6.78795 4.16353 6.72737 3.74823C6.66678 3.33294 6.45905 2.95322 6.14201 2.67823C5.82496 2.40324 5.41969 2.25127 5 2.25C4.59543 2.24997 4.20333 2.39008 3.8904 2.6465C3.57746 2.90292 3.36301 3.25982 3.2835 3.6565L4.2645 3.853C4.29234 3.71372 4.35916 3.5852 4.45718 3.48241C4.55521 3.37962 4.68041 3.30677 4.81821 3.27235C4.95602 3.23793 5.10077 3.24335 5.23561 3.28798C5.37046 3.33261 5.48986 3.41462 5.57992 3.52446C5.66998 3.63429 5.727 3.76745 5.74434 3.90842C5.76168 4.0494 5.73864 4.1924 5.67789 4.32079C5.61713 4.44918 5.52117 4.55768 5.40116 4.63366C5.28116 4.70965 5.14204 4.74999 5 4.75C4.86739 4.75 4.74021 4.80268 4.64645 4.89645C4.55268 4.99021 4.5 5.11739 4.5 5.25V6H5.5V5.6775Z"
              fill="#8C0303"
            />
          </svg>
          <div
            class="bg-white text-primary px-3 py-2 mt-3 d-flex align-items-center tool"
          >
            <b-icon icon="credit-card-fill" />
            <div class="ml-3">
              <p class="mb-1">
                Recurring donations are through debit/credit card only.
              </p>
              <p class="mb-1">
                In view of card processing fees, we request a
                <u class="font-weight-bold">minimum of $10</u> if you wish to
                pay using a debit/credit card.
              </p>
              <p class="mb-0">
                For one-off donations below $10, kindly use PayNow or Online
                Bank Transfer.
              </p>
            </div>
          </div>
        </div>
      </legend>
      <b-form-radio-group
        :options="payment.options"
        v-model="payment.value"
        buttons
        button-variant="outline-primary"
        size="md"
        class="split-radio-btns narrow"
      />
    </b-form-group>

    <b-alert variant="warning" show v-if="anon">
      <p class="mb-2">
        Automatically recurring donations and tax deductions are not available
        for anonymous donors.
      </p>
      <p class="mb-3">
        As we do not track your contact details, we will not be able to issue an
        payment receipt for PayLah, Cheque or Bank Transfers as well.
      </p>
      <b-button @click="donorType.value = ''"
        >I do not wish to donate anonymously</b-button
      >
    </b-alert>

    <div v-if="show_sign_in" class="bg-white py-3 px-4" style="width: 100%">
      <div class="d-flex align-items-center flex-wrap"></div>
      <b-row>
        <b-col cols="12" md="6">
          <p class="small" v-if="code_sending">
            You can request for another code in 1 minute
          </p>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            label="Code Verification"
            description="Check your email for the code"
            v-if="code_sent"
          >
            <b-input-group>
              <b-input
                type="text"
                placeholder="Enter Code."
                v-model="code"
                :disabled="logged_in"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click="$emit('check-otp', { email, code })"
                  :disabled="verifying_code"
                  >Verify Code</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div style="width: 100%" class="mx-auto mt-5 pt-5 pb-5">
      <b-button
        block
        variant="primary"
        size="md"
        style="
          text-transform: uppercase;
          padding: 1.5rem 1rem;
          font-size: 28px;
          font-weight: 400;
          margin-left: auto;
        "
        @click="next"
        >Donate</b-button
      >
      <img src="@/assets/paymentmethods.png" style="width: 100%" class="mb-2" />
      <p class="text-muted" v-if="form_invalid_msg">
        {{ form_invalid_msg }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "part1",
  props: {
    show_sign_in: Boolean,
    invalid_code: Boolean,
    code_sent: Boolean,
    logged_in: Boolean,
    verifying_code: Boolean,
    anon: Boolean,
    checkout: Object,
    fb_link: String,
    google_link: String,
    donation_data: Object,
  },
  data() {
    let checkout = this.checkout;
    // console.log(checkout);
    let amt = 10;
    let customamt = 10;
    let showDonationRequiredMessage = false;

    if (amt) {
      if (![20, 70, 100, 200, 1000, 2000].includes(amt)) {
        customamt = amt;
      }
    }
    if (this.anon) {
      checkout.Donation_Frequency = -1;
    }

    checkout.Donation_Frequency = -1;

    let paymentOpts = [
      {
        text: "Credit / Debit Card",
        value: "Credit / Debit Card",
        disabled: false,
      },
    ];

    if (!checkout.Donor_Type) {
      checkout.Donor_Type = "Individual";
    }

    if (checkout.Donation_Frequency === -1) {
      paymentOpts.push("PayNow", "Online Bank Transfer", "Cheque");
    }

    let paymentFreq = [
      { text: "Give Once", value: -1 },
      {
        text: "Donate Monthly",
        value: 1,
      },
    ];

    if (
      checkout.Donation_Mode &&
      checkout.Donation_Mode != "Credit / Debit Card"
    ) {
      paymentFreq.length = 1;
    }
    let donorTypeOpts = [
      { text: "Individual", value: "Individual" },
      { text: "Company/Organisation", value: "Corporate" },
    ];

    if (!this.logged_in) {
      donorTypeOpts.push({ text: "Anonymous Donor", value: "Anonymous" });
    }

    return {
      donorType: {
        value: checkout.Donor_Type,
        options: donorTypeOpts,
      },
      freq: {
        value: checkout.Donation_Frequency,
        options: paymentFreq,
      },
      amt,
      customamt,
      showDonationRequiredMessage,
      payment: {
        value: checkout.Donation_Mode,
        options: paymentOpts,
      },
      email: "",
      code: "",
      code_sending: false,
      code_sending_timer: null,
    };
  },
  computed: {
    form_invalid_msg() {
      if (
        !this.donorType.value ||
        !this.freq.value ||
        !this.amt ||
        !this.payment.value
      ) {
        return "As an IPC registered charity, all donations to HealthServe are 250% tax deductible.";
      }
      if (this.show_sign_in) {
        if (!(this.email && this.code)) {
          //Identify yourself via online accounts, or a one-time code sent to your email to continue;
          return "";
        }
        if (this.invalid_code) {
          //Check and make sure you have filled in and verified your code
          return "";
        }
      }
      return "";
    },
    form_invalid() {
      return Boolean(this.form_invalid_msg);
    },
  },
  methods: {
    cleanAmt(val) {
      if (val < 1) {
        return 1;
      }
      return Math.floor(val) || 1;
    },
    radio_text(type) {
      return type?.text ? type?.text : type?.value ? type?.value : type;
    },
    radio_value(type) {
      return type?.value ? type?.value : type;
    },
    radio_disable(type) {
      return type?.disabled || false;
    },
    next() {
      let checkout = {
        Donation_Cash_Value: this.amt,
        Donation_Frequency: this.freq.value,
        Donation_Mode: this.payment.value,
        Donor_Portal_Remarks: "Donation for HealthServe Charity Golf 2024",
      };
      if (this.donorType.value) {
        checkout.Donor_Type = this.donorType.value;
      }

      if (checkout.Donation_Cash_Value > 0) {
        this.showDonationRequiredMessage = false;
        this.$emit("next", checkout);
      } else {
        this.showDonationRequiredMessage = true;
      }
    },
    get_otp() {
      if (this.code_sending) {
        return;
      }
      this.code_sending = true;
      this.$emit("get-otp", this.email);

      this.code_sending_timer = setTimeout(() => {
        this.code_sending = false;
        this.code_sending_timer = null;
      }, 60000);
    },
    popup(link) {
      const w = 600;
      const h = 700;
      const y = window.top.outerHeight / 2 + window.top.screenY - h / 2;
      const x = window.top.outerWidth / 2 + window.top.screenX - w / 2;

      window.open(
        link,
        "login_popup",
        `menubar=0,resizable=1,width=${w}, height=${h}, top=${y}, left=${x}`
      );
    },
  },
  mounted() {
    console.log("mounted");
    this.freq.value = -1;
    this.donorType.value = "Individual";
    console.log(this.checkout);
  },
  watch: {
    email() {
      this.code = "";
      this.$emit("code-verify-reset", true);
    },
    code() {
      this.$emit("code-verify-reset", false);
    },
    code_sent(val) {
      if (!val) {
        this.code_sending = false;
        if (this.code_sending_timer) {
          clearTimeout(this.code_sending_timer);
          this.code_sending_timer = null;
        }
      }
    },
    customamt(amt) {
      this.amt = amt;
    },
    amt(amt) {
      if (amt < 10) {
        this.payment.options[0].disabled = true;
        if (this.payment.value == "Credit / Debit Card") {
          this.payment.value = null;
        }
      } else {
        this.payment.options[0].disabled = false;
      }
    },
    "payment.value"(type) {
      if (type && type != "Credit / Debit Card") {
        if (this.freq.value != -1) {
          let r = confirm(
            "This payment mode cannot be used for recurring donations. Do you wish to switch to a one-time donation?"
          );
          if (!r) {
            this.$nextTick(() => {
              this.payment.value = "Credit / Debit Card";
            });
            return;
          }
        }
        this.freq.value = -1;
        this.freq.options = [
          { text: "Once", value: -1, title: "One-off payment" },
        ];
        return;
      }

      this.freq.options = [
        { text: "Give Once", value: -1 },
        {
          text: "Donate Monthly",
          value: 1,
        },
      ];
    },
    "donorType.value"(val) {
      if (val == "Anonymous") {
        val = "Anonymous Donor";
        // this.freq.value = -1;
      }

      this.$emit("donortype", val);
    },
    "freq.value"(val) {
      if (val === 1) {
        this.payment.options = [
          {
            text: "Credit / Debit Card",
            value: "Credit / Debit Card",
            disabled: false,
          },
        ];
      } else {
        this.payment.options = [
          {
            text: "Credit / Debit Card",
            value: "Credit / Debit Card",
            disabled: false,
          },
          "PayNow",
          "Online Bank Transfer",
          "Cheque",
        ];
      }
    },
    logged_in(val) {
      if (!val) {
        this.donorType.options = [
          { text: "Individual", value: "Individual" },
          { text: "Company/Organization", value: "Corporate" },
          { text: "Anonymous Donor", value: "Anonymous" },
        ];
      } else {
        this.donorType.options = [
          { text: "Individual", value: "Individual" },
          { text: "Company/Organization", value: "Corporate" },
        ];
      }
    },
  },
};
</script>
